var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"hs",attrs:{"src":require("../assets/img/logo_main.png")}}),_c('p',{staticClass:"pm p1"},[_vm._v("地址：深圳市南山区粤海街道深圳湾科技生态园一期2栋C座508")]),_c('p',{staticClass:"pm p2"},[_vm._v("邮箱："),_c('a',{attrs:{"href":"mailto:info@highsharp.com"}},[_vm._v("info@highsharp.com")])])])
}]

export { render, staticRenderFns }